import { render } from "./AllCourses.vue?vue&type=template&id=1a2f7260&scoped=true"
import script from "./AllCourses.vue?vue&type=script&lang=js"
export * from "./AllCourses.vue?vue&type=script&lang=js"

import "./AllCourses.vue?vue&type=style&index=0&id=1a2f7260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2f7260"]])

export default __exports__